import { Box } from "@mui/material";
import { useState } from "react";
import CustomText from "../components/CustomText";

const CustomQuietZones = () => {
  const [zonaActiva, setZonaActiva] = useState(zonas[0]);

  const handleClick = (zona) => {
    setZonaActiva(zona);
  };

  const handlePrevious = () => {
    const currentIndex = zonas.findIndex((zona) => zona.id === zonaActiva.id);
    const previousIndex =
      currentIndex === 0 ? zonas.length - 1 : currentIndex - 1;
    setZonaActiva(zonas[previousIndex]);
  };

  const handleNext = () => {
    const currentIndex = zonas.findIndex((zona) => zona.id === zonaActiva.id);
    const nextIndex = currentIndex === zonas.length - 1 ? 0 : currentIndex + 1;
    setZonaActiva(zonas[nextIndex]);
  };

  return (
    <Box sx={design.zonas}>
      <Box sx={design.zonasHeader}>
        <CustomText
          color="#782A9F"
          fontWeight={500}
          fontFamily="Nunito"
          textAlign="center"
          width="100%"
          sx={design.TextCH}
        >
          Bienestar y confort
        </CustomText>
        <CustomText
          color="#2B418F"
          fontWeight={700}
          fontFamily="Nunito"
          textAlign="center"
          width="100%"
          sx={design.Titulo}
        >
          Zonas pensadas para tu tranquilidad
        </CustomText>
      </Box>
      <Box sx={design.contenido}>
        <Box sx={design.galeria}>
          <Box sx={design.imagen}>
            <Box
              component="img"
              src={zonaActiva.imagen}
              alt={zonaActiva.nombre}
              sx={design.img}
            />
            <Box sx={design.overlay}>
              <CustomText
                color="#FFF"
                fontWeight={600}
                fontFamily="Nunito"
                textAlign="left"
                width="100%"
                sx={design.Nombre}
              >
                {zonaActiva.nombre}
              </CustomText>
            </Box>
            <Box onClick={handlePrevious} sx={design.arrowLeft}>
              ‹
            </Box>
            <Box onClick={handleNext} sx={design.arrowRight}>
              ›
            </Box>
          </Box>
          <Box sx={design.imagenesSecundarias}>
            {zonas.map((zona) => {
              const activa = zona.id === zonaActiva.id;
              return (
                <Box
                  key={zona.id}
                  sx={{
                    ...design.imagen,
                    ...design.imagenSecundaria,
                    border: activa ? "2px solid #782A9F" : "0px solid #782A9F",
                  }}
                  onClick={() => handleClick(zona)}
                >
                  <Box
                    component="img"
                    src={zona.imagen}
                    alt={zona.nombre}
                    sx={{
                      ...design.img,
                      opacity: activa ? 1 : 0.6,
                    }}
                  />
                </Box>
              );
            })}
          </Box>
        </Box>
        <Box>
          <Box sx={design.infoBox}>
            <CustomText
              color="#29458D"
              fontWeight={700}
              fontFamily="Nunito"
              textAlign="left"
              width="100%"
              sx={design.TituloCard}
            >
              {zonaActiva.nombre}
            </CustomText>
            <CustomText
              color="#000"
              fontWeight={600}
              fontFamily="Nunito"
              textAlign="left"
              width="100%"
              sx={design.TextDes}
            >
              {zonaActiva.descripcion}
              <br />
              <br />
              {zonaActiva.descripcion2}
            </CustomText>
          </Box>
          <CustomText
            color="#29458D"
            fontWeight={700}
            fontFamily="Nunito"
            textAlign="left"
            width="100%"
            sx={design.Consu}
          >
            Consultorios y espacios generales disponibles para renta.
          </CustomText>
        </Box>
      </Box>
    </Box>
  );
};

export default CustomQuietZones;

const design = {
  zonas: {
    position: "relative",
    overflow: "hidden",
    "&::before": {
      content: '""',
      position: "absolute",
      inset: 0,
      backgroundImage:
        "url(https://centromedicomedam.com/IMG/centromedicoMEDAM/backgrond_color_Quiet_Zones.svg)",
      backgroundSize: "cover",
      backgroundRepeat: "repeat",
      backgroundPosition: "center center",
      opacity: 0.5,
      zIndex: 0,
      pointerEvents: "none",
    },
    "& > *": {
      position: "relative",
      zIndex: 1,
    },
    py: { xs: 1, sm: 1, md: 1, lg: 3 },
  },
  zonasHeader: {
    position: "relative",
    zIndex: 1,
    width: "100%",
    maxWidth: "1080px",
    mx: "auto",
    textAlign: "left",
    mb: { xs: 4, sm: 5, md: 4 },
    opacity: 1,
  },
  contenido: {
    position: "relative",
    zIndex: 1,
    width: "97%",
    maxWidth: "1080px",
    mx: "auto",
    display: "grid",
    gridTemplateColumns: {
      xs: "1fr",
      md: "minmax(0, 1fr) 280px",
      lg: "minmax(0, 1fr) 300px",
    },
    gap: { xs: 4, sm: 4, md: 3, lg: 4 },
    alignItems: "start",
  },
  galeria: {
    width: "100%",
    minWidth: 0,
    display: "flex",
    flexDirection: "column",
  },
  imagen: {
    position: "relative",
    overflow: "hidden",
    cursor: "pointer",
    borderRadius: "20px",
    backgroundColor: "#ddd",
    border: "2px solid #782A9F",
    boxShadow: "0 4px 15px rgba(41,69,141,0.12)",
    transition: "box-shadow 0.3s ease, transform 0.3s ease, opacity 0.3s ease",
    "&:hover": {
      boxShadow: "0 8px 25px rgba(41,69,141,0.18)",
    },
    width: "100%",
    height: { xs: "220px", sm: "260px", md: "310px", lg: "325px" },
    mb: { xs: 1.5, sm: 2 },
  },
  imagenesSecundarias: {
    display: "grid",
    gridTemplateColumns: {
      xs: "repeat(4, 1fr)",
      sm: "repeat(4, 1fr)",
    },
    gap: { xs: 1.5, sm: 2 },
    width: "100%",
  },
  imagenSecundaria: {
    width: "100%",
    height: { xs: "80px", sm: "105px", md: "110px", lg: "115px" },
    mb: 0,
    borderRadius: "12px",
  },
  img: {
    width: "100%",
    height: "100%",
    display: "block",
    objectFit: "cover",
    transition: "transform 0.5s ease, filter 0.5s ease",
    "&:hover": { transform: "scale(1.06)" },
  },
  overlay: {
    position: "absolute",
    inset: 0,
    display: "flex",
    alignItems: "flex-end",
    padding: { xs: "15px", sm: "18px", md: "20px" },
    boxSizing: "border-box",
    background:
      "linear-gradient(180deg, transparent 35%, rgba(0,0,0,0.78) 100%)",
    transition: "opacity 0.3s ease",
    pointerEvents: "none",
    opacity: 1,
  },
  arrowLeft: {
    position: "absolute",
    left: { xs: "10px", sm: "15px", md: "20px" },
    top: "50%",
    transform: "translateY(-50%)",
    width: { xs: "38px", sm: "45px" },
    height: { xs: "38px", sm: "45px" },
    borderRadius: "50%",
    backgroundColor: "rgba(255,255,255,0.85)",
    color: "#29458D",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    fontSize: { xs: "32px", sm: "38px" },
    lineHeight: 1,
    cursor: "pointer",
    zIndex: 5,
    userSelect: "none",
    transition: "all 0.2s ease",
    "&:hover": {
      backgroundColor: "#FFF",
      transform: "translateY(-50%) scale(1.05)",
    },
  },
  arrowRight: {
    position: "absolute",
    right: { xs: "10px", sm: "15px", md: "20px" },
    top: "50%",
    transform: "translateY(-50%)",
    width: { xs: "38px", sm: "45px" },
    height: { xs: "38px", sm: "45px" },
    borderRadius: "50%",
    backgroundColor: "rgba(255,255,255,0.85)",
    color: "#29458D",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    fontSize: { xs: "32px", sm: "38px" },
    lineHeight: 1,
    cursor: "pointer",
    zIndex: 5,
    userSelect: "none",
    transition: "all 0.2s ease",
    "&:hover": {
      backgroundColor: "#FFF",
      transform: "translateY(-50%) scale(1.05)",
    },
  },
  infoBox: {
    width: "100%",
    padding: { xs: "20px", sm: "23px", md: "35px", lg: "15px" },
    mb: 2,
    border: "2px solid #C7D6F2",
    borderRadius: "20px",
    background: "#FFF",
    opacity: 1,
    backdropFilter: "blur(18px)",
    WebkitBackdropFilter: "blur(1px)",
    boxShadow:
      "0 4px 18px rgba(41,69,141,0.06), 0 12px 45px rgba(41,69,141,0.08)",
  },
  TextCH: {
    fontSize: { xs: 17, sm: 17, md: 17, lg: 17 },
    lineHeight: 1.2,
    mt: 2,
  },
  Titulo: {
    fontSize: { xs: 32, sm: 42, md: 55, lg: 55 },
    lineHeight: 1.1,
    mb: 2,
  },
  Nombre: {
    fontSize: { xs: "16px", sm: "18px", md: "19px" },
  },
  TituloCard: {
    fontSize: { xs: "21px", sm: "23px", md: "27px" },
    lineHeight: 1,
    mb: 2,
  },
  TextDes: {
    fontSize: { xs: "13px", sm: "15px", md: "17px" },
  },
  Consu: {
    mt: 2.5,
    px: 1,
    fontSize: { xs: "13px", sm: "15px" },
  },
};

const zonas = [
  {
    id: 1,
    nombre: "Jardín exterior",
    descripcion:
      "Dentro de MEDAM creemos en la importancia de contar con espacios que inviten a hacer una pausa.",
    descripcion2:
      "La presencia de áreas verdes y espacios al aire libre forman parte de una experiencia más humana, creando un espacio libre para pacientes, familiares, visitantes y colaboradores que aporta calma y bienestar dentro del entorno hospitalario.",
    imagen:
      "https://centromedicomedam.com/IMG/centromedicoMEDAM/Acceso_Principal_Medam.png",
  },
  {
    id: 2,
    nombre: "Terraza de descanso",
    descripcion:
      "Nuestra terraza, pensada como un espacio abierto y confortable, complementa la experiencia dentro de MEDAM En este espacio puedes disfrutar de un momento de descanso, conversar o simplemente cambiar de ambiente.",
    descripcion2:
      "Más que un espacio de transición, buscamos que sea un área agradable para detenerse un momento, tomar aire y continuar.",
    imagen:
      "https://centromedicomedam.com/IMG/centromedicoMEDAM/Terraza_Medam.png",
  },
  {
    id: 3,
    nombre: "Auditorio",
    descripcion:
      "MEDAM entiende que la salud también avanza através del conocimiento.",
    descripcion2:
      "Por ello el auditorio será el punto de encuentro para profesionales, colaboradores e invitados a actividades, conectadas a reunir el aprendizaje, la actualización y el intercambio de ideas para fomentar el desarrollo académico.",
    imagen:
      "https://centromedicomedam.com/IMG/centromedicoMEDAM/Auditorio_principal_MEDAM.png",
  },
  {
    id: 4,
    nombre: "Sala de reuniones",
    descripcion:
      "Detras de cada servicio existe un equipo trabajando en conjunto.",
    descripcion2:
      "Nuestra sala de juntas es un lugar destinado al dialogo y la construcción de ideas, análisis de proyectos, establecimiento de objetivos, toma de decisiones y la búsqueda de la mejora continua.",
    imagen:
      "https://centromedicomedam.com/IMG/centromedicoMEDAM/Sala_de_Juntas_MEDAM.png",
  },
];
